angular
  .module('caferealtor.listing.network.publish_confirm', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/listing/publish/:listingId', {
        template: require('./publish_confirm.html'),
        controller: 'PublishConfirmCtrl',
      });
    },
  ])

  .controller('PublishConfirmCtrl', [
    '$scope',
    '$resource',
    '$location',
    '$routeParams',
    '$rootScope',
    '$q',
    '$timeout',
    'ToastService',
    function (
      $scope,
      $resource,
      $location,
      $routeParams,
      $rootScope,
      $q,
      $timeout,
      ToastService,
    ) {
      $scope.listingId = $routeParams.listingId;

      const PublishListing = $resource('/listing/:id/publish', { id: '@id' });
      const Listing = $resource('/listing/:id', { id: '@id' });
      const NetworkOrg = $resource('/org/network');

      $scope.orgs = [];

      const promises = [
        NetworkOrg.query().$promise,
        Listing.get({ id: $scope.listingId }).$promise,
      ];

      $q.all(promises)
        .then(function (result) {
          const data = result[0];
          _.each(data, function (org) {
            $scope.orgs.push(org.name);
          });
          $scope.dataLoaded = true;

          const listing = result[1];
          $scope.address = listing.line1;
          if (listing.line2) {
            $scope.address += `, ${listing.line2}`;
          }
          $scope.address.trim();
        })
        .finally(function () {
          $scope.dataLoaded = true;
        });

      $scope.publish = function () {
        $scope.dataLoaded = false;
        PublishListing.save(
          { id: $scope.listingId },
          function () {
            const location = '/listing/network_map';
            $location.path(location);
          },
          function (err) {
            if (err.status === 400) {
              swal(
                {
                  title: 'Your listing is currently set to draft',
                  text: 'You cannot publish a private listing to the network. You must first publish it to your brokerage.',
                  html: true,
                  type: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#62cb31',
                  confirmButtonText: 'Ok',
                  closeOnConfirm: true,
                },
                () => {
                  $timeout(() => {
                    const { listingId } = $routeParams;
                    $location.path(`/listing/${listingId}/view`);
                  });
                },
              );
            } else {
              ToastService.add({
                message: err.data,
                type: 'danger',
                removeAfter: 20,
              });
            }
            $scope.dataLoaded = true;
          },
        );
      };
    },
  ]);
